/*fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {

      var flag_c = 0;

    cart.items.forEach(item => {

      console.log(item.product_id);
      const properties = item.properties;
      const extendedWarranty = properties['Extended Warranty']; // Using bracket notation
      
      if(extendedWarranty == "Yes"){

        flag_c = 1;
      }    
    
    });

    if(flag_c == 1){

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          // Add a new line item with a custom title and price
          items: [
            {
              title: "Extra Charge",
              price: 100.00,
              quantity: 1,
              taxable: true
            }
          ]
        })
      })
      .then(response => {

         // Handle the response from the server
          if (response.ok) {
          } else {
            // The update was not successful
            console.error("Error adding extra charge to cart: " + error);
          }
      })
      .catch(error => {
        // Handle any errors that occur
      });


    }     


  });
*/



/*// Set the product ID and quantity to add
var productId = 6804518600739;
var quantity = 1;

// Build the request URL
var requestUrl = '/cart/add.js?id=' + productId + '&quantity=' + quantity;

// Send the fetch request
fetch(requestUrl, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  }
})
  .then(response => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('Error adding product to cart');
    }
  })
  .then(lineItem => {
    console.log('Product added to cart:', lineItem);
  })
  .catch(error => {
    console.error(error);
  });*/

/*
const variantId = 6804518600739; // Replace this with the ID of the product variant you want to add
const quantity = 1; // Replace this with the quantity you want to add

fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    quantity: quantity,
    id: variantId
  })
})
.then(response => {
  // Handle the response from the server
})
.catch(error => {
  // Handle any errors that occur
});*/



/*fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    items: [
      {
        quantity: 1,
        id: 6804552482851
      }
    ]
  })
})
.then(response => response.json())
.then(data => console.log(data))
.catch(error => console.error(error))
*/


/* =====================================================================
   Extended Warranty — tiered pricing + product-page add-on toggle
   ---------------------------------------------------------------------
   The "warranty" product carries two price tiers as separate variants:
   $299 (carts up to $10,000) and $499 (carts above $10,000). Tier data is
   emitted by snippets/warranty-tier-data.liquid as #warranty-tier-data.

   - On product pages, the checkbox (snippets/warranty-addon.liquid) adds /
     removes the tier-appropriate warranty variant via the cart AJAX API.
   - On the cart page, if a warranty is already in the cart at the wrong tier
     (e.g. the subtotal crossed $10,000 after it was added), it is swapped to
     the correct variant.

   Everything here is independent of the main Add-to-Cart flow so it can never
   interfere with the normal checkout path.
   ===================================================================== */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function getJSON(url) {
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('Request failed: ' + url);
      return r.json();
    });
  }

  // Parse the tier config rendered by warranty-tier-data.liquid. Returns
  // { threshold, variantIds, lowId, highId } or null when unavailable.
  function parseTier() {
    var el = document.getElementById('warranty-tier-data');
    if (!el) return null;
    try {
      var data = JSON.parse(el.textContent);
      if (!data || !data.variants || !data.variants.length) return null;
      data.variants.sort(function (a, b) { return a.price - b.price; });
      return {
        threshold: data.threshold,
        variants: data.variants,
        variantIds: data.variants.map(function (v) { return v.id; }),
        lowId: data.variants[0].id,
        highId: data.variants[data.variants.length - 1].id
      };
    } catch (e) {
      return null;
    }
  }

  // Merchandise subtotal (cents), excluding any warranty line items.
  function merchSubtotal(cart, warrantyIds) {
    var sum = 0;
    (cart.items || []).forEach(function (it) {
      if (warrantyIds.indexOf(it.variant_id) === -1) sum += it.final_line_price;
    });
    return sum;
  }

  // The warranty variant that should apply given the current cart.
  function desiredVariantId(cart, tier) {
    if (!tier) return null;
    return merchSubtotal(cart, tier.variantIds) > tier.threshold ? tier.highId : tier.lowId;
  }

  function findWarrantyLine(cart, warrantyIds) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (warrantyIds.indexOf(items[i].variant_id) !== -1) return items[i];
    }
    return null;
  }

  function isCartPage() {
    return /(^|\/)cart(\/|$|\?)/.test(window.location.pathname) ||
      !!document.querySelector('.cart--section, [data-cart-sidebar]');
  }

  // ---- Cart page: keep an already-added warranty on the correct tier ----
  // Re-checks on load, on every cart re-render (quantity / removal), and right
  // before checkout so the charged tier always matches the current subtotal.
  function setupCartReconcile(tier) {
    var inflight = null;       // single-flight lock for the swap operation
    var checkoutPending = false;
    var checkoutCleared = false;

    // Resolves to true if it had to swap the warranty variant, false otherwise.
    function reconcile() {
      if (inflight) return inflight;
      inflight = getJSON('/cart.js').then(function (cart) {
        var line = findWarrantyLine(cart, tier.variantIds);
        if (!line) return false;
        var want = desiredVariantId(cart, tier);
        if (!want || line.variant_id === want) return false;
        return postJSON('/cart/change.js', { id: line.key, quantity: 0 })
          .then(function () { return postJSON('/cart/add.js', { id: want, quantity: 1 }); })
          .then(function () { return true; });
      });
      inflight.then(function () { inflight = null; }, function () { inflight = null; });
      return inflight;
    }

    // Reload to refresh the displayed warranty price — but only when an actual
    // swap happened and we're not mid-checkout.
    function reconcileAndRefresh() {
      reconcile().then(function (swapped) {
        if (swapped && !checkoutPending) window.location.reload();
      }).catch(function () {});
    }

    reconcileAndRefresh();
    // Empire fires this on the window after it re-renders the cart (qty/remove).
    window.addEventListener('cartcount:update', reconcileAndRefresh);

    // Hold the Checkout request until any needed swap completes.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[name="checkout"]');
      if (!btn || checkoutCleared) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      checkoutPending = true;
      reconcile().then(proceed, proceed);
      function proceed() {
        checkoutCleared = true;
        btn.click(); // re-dispatch; passes through now that the tier is correct
      }
    }, true);
  }

  // ---- Product page: the add / remove checkbox ----
  function setupToggle(toggle, tier) {
    var status = document.querySelector('[data-warranty-status]');
    var meta = document.querySelector('.pdp-warranty-addon__meta');
    var fallbackId = parseInt(toggle.getAttribute('data-variant-id'), 10) || null;
    var warrantyIds = tier ? tier.variantIds : (fallbackId ? [fallbackId] : []);

    // On the product page the tier is driven by THIS product's price, not the
    // cart subtotal: products over the threshold get the higher warranty tier,
    // regardless of what else is in the cart. (Cart-page reconciliation, which
    // is subtotal-based, stays as-is — a >$10k product makes the subtotal >$10k
    // anyway, so the two never disagree.)
    var productPrice = parseInt(toggle.getAttribute('data-product-price'), 10);
    if (isNaN(productPrice)) productPrice = null;
    function desiredForProduct() {
      if (!tier) return fallbackId;
      if (productPrice === null) return tier.lowId;
      return productPrice > tier.threshold ? tier.highId : tier.lowId;
    }

    // Relocate the add-on to its own row below the "View Cushion Options"
    // block (theme-rendered, normal flow → no overlap). Fallbacks: top of the
    // form area, then its default in-form spot.
    var addon = document.querySelector('[data-warranty-addon]');
    if (addon && addon.parentNode) {
      var cushionDesc = document.querySelector('.cushion-pdp-desc');
      if (cushionDesc && cushionDesc.parentNode) {
        cushionDesc.parentNode.insertBefore(addon, cushionDesc.nextSibling);
      } else {
        var formArea = document.querySelector('[data-product-form-area]');
        if (formArea && addon !== formArea.firstElementChild) {
          formArea.insertBefore(addon, formArea.firstChild);
        }
      }
    }

    function setStatus(message, state) {
      if (!status) return;
      status.textContent = message || '';
      status.className = 'pdp-warranty-addon__status' + (state ? ' is-' + state : '');
    }

    // Show the price tier that applies to the current cart.
    function updateMetaPrice(variantId) {
      if (!meta || !tier) return;
      var match = tier.variants.filter(function (v) { return v.id === variantId; })[0];
      if (!match) return;
      meta.textContent = '$' + Math.round(match.price / 100) + ' · 5-Year Protection';
    }

    // Reflect this product's tier immediately, independent of the cart.
    updateMetaPrice(desiredForProduct());

    getJSON('/cart.js').then(function (cart) {
      if (findWarrantyLine(cart, warrantyIds)) {
        toggle.checked = true;
        setStatus('Added to your cart', 'added');
      }
    }).catch(function () {});

    toggle.addEventListener('change', function () {
      toggle.disabled = true;
      setStatus('Updating…', 'loading');

      if (toggle.checked) {
        var want = desiredForProduct() || fallbackId;
        updateMetaPrice(want);
        postJSON('/cart/add.js', { id: want, quantity: 1 })
          .then(function () { setStatus('✓ Added to your cart', 'added'); })
          .catch(function () {
            toggle.checked = false;
            setStatus('Could not add the warranty. Please try again.', 'error');
          })
          .then(function () { toggle.disabled = false; });
      } else {
        getJSON('/cart.js')
          .then(function (cart) {
            var line = findWarrantyLine(cart, warrantyIds);
            if (!line) return null;
            return postJSON('/cart/change.js', { id: line.key, quantity: 0 });
          })
          .then(function () { setStatus('', null); })
          .catch(function () {
            toggle.checked = true;
            setStatus('Could not remove the warranty. Please try again.', 'error');
          })
          .then(function () { toggle.disabled = false; });
      }
    });
  }

  ready(function () {
    var tier = parseTier();

    var toggle = document.querySelector('[data-warranty-toggle]');
    if (toggle) setupToggle(toggle, tier);

    // Only reconcile when there are genuinely two distinct tiers to choose from.
    if (tier && tier.lowId !== tier.highId && isCartPage()) {
      setupCartReconcile(tier);
    }
  });
})();

